import { render, staticRenderFns } from "./SqlAdmin.vue?vue&type=template&id=5cc554e1&scoped=true&"
import script from "./SqlAdmin.vue?vue&type=script&lang=js&"
export * from "./SqlAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SqlAdmin.vue?vue&type=style&index=0&id=5cc554e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc554e1",
  null
  
)

export default component.exports